<template>
  <el-form
    :model="contact"
  >
    <el-row :gutter="10">
      <el-col :span="8">
        <el-form-item
          label="Title"
        >
          <el-input
            v-model="contact.carriercont_title"
            placeholder="Title"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Name"
        >
          <el-input
            v-model="contact.carriercont_name"
            placeholder="name"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Location"
        >
          <el-input
            v-model="contact.carriercont_location"
            placeholder="Location"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="8">
        <el-form-item
          label="Phone"
        >
          <el-input
            v-model="contact.carriercont_phone"
            placeholder="Phone"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Mobile"
        >
          <el-input
            v-model="contact.carriercont_mobile"
            placeholder="Mobile"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Email"
        >
          <el-input
            v-model="contact.carriercont_email"
            type="email"
            placeholder="Email"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Include in Pickups"
        >
          <el-switch
            v-model="contact.carriercont_incpickups"
            inactive-text="No"
            active-text="Yes"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        :span="24"
      >
        <el-form-item
          label="Notes"
        >
          <el-input
            v-model="contact.carriercont_notes"
            type="textarea"
            rows="8"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import CarrierContact from '@/plugins/sdk/resources/Carrier/Contact'

export default {
  props: {
    contact: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof CarrierContact
      }
    }
  }
}
</script>
